import { createLightTheme, FluentProvider, Theme } from '@fluentui/react-components';
import type { WorkloadClientAPI, WorkloadSettings } from '@ms-fabric/workload-client';
import { createWorkloadClient } from '@ms-fabric/workload-client';
import { createBrowserHistory, History } from 'history';
import { createContext, FC, ReactNode, Suspense, useContext, useEffect, useState } from 'react';

const extensionClient: WorkloadClientAPI = createWorkloadClient();
const history = createBrowserHistory();
export type FabricContextType = {
	extensionClient: WorkloadClientAPI;
	history: History;
	extensionSettings?: WorkloadSettings;
	currentTheme?: Theme;
};

const ContextValue: FabricContextType = {
	extensionClient,
	history,
};
const Context = createContext<FabricContextType>(ContextValue);

export const useFabricContext = (): FabricContextType => useContext(Context);

export const FabricContext: FC<{
	children: ReactNode;
	loader: NonNullable<ReactNode> | null;
}> = ({ children, loader }) => {
	const [extensionSettings, setExtensionSettings] = useState<WorkloadSettings>();
	const [currentTheme, setTheme] = useState<Theme>();

	const init = async () => {
		ContextValue.extensionClient.navigation.onNavigate((route) => {
			ContextValue.history.push(route.targetUrl);
		});
		//Set the theme from accent color of fabric app
		const themeConfig = await extensionClient.theme.get();
		setTheme(createLightTheme(themeConfig.accentColors));
		//Set the initial extension settings;
		const settings = await ContextValue.extensionClient.settings.get();
		setExtensionSettings(settings);
		//Update the setting on change.
		ContextValue.extensionClient.settings.onChange(setExtensionSettings);

		//TODO:: Handle theme update.
		//ContextValue.extensionClient.theme.onChange()
	};

	useEffect(() => {
		init();
	}, []);

	return (
		<FluentProvider style={{ height: '100%' }} theme={currentTheme}>
			<Suspense fallback={loader}>
				<Context.Provider value={{ ...ContextValue, extensionSettings, currentTheme }}>{children}</Context.Provider>
			</Suspense>
		</FluentProvider>
	);
};
